<template>
<div class="bmdiv pfixed tcenter" v-show="isShowSign">
  <div class="content-div">
    <a href="javascript:void(0);" class="close pabsolute br50 hbig twhite" @click="hiddenSign">X</a>
    <vue-signature-pro ref="signature1" w="375px" h="250px" style="border: #000 solid 1px;margin: auto;margin-top: 4.6vw;"></vue-signature-pro>
    <button @click="save">确定</button>
    <button @click="clear">清除</button>
    <button @click="undo">撤销</button>
  </div>

</div>
</template>

<script>
import vueSignaturePro from 'vue-signature'
export default {
  name: "vueSignatureMobile",
  props:[
    'isShowSign',
  ],
  components:{
    vueSignaturePro
  },
  methods:{
    hiddenSign:function () {
      this.$emit('update:is-show-sign', false)
      // this.$emit('hide-sign-up');
    },
    save(){
      var _this = this;
      // var png = _this.$refs.signature1.save()
      var jpeg = _this.$refs.signature1.save('image/jpeg')
      // var svg = _this.$refs.signature1.save('image/svg+xml');
      // console.log(png);
      // console.log(jpeg)
      // console.log(svg)


      var data_blob = this.dataURItoBlob(jpeg);
      this.$emit('set-sign',data_blob,jpeg)
      this.$emit('update:is-show-sign', false)
      // this.$emit('update:electronic-signature-file',data_blob);
      // this.$emit('update:electronic_signature',true);
      // let param = new FormData();
      // param.append('pic_passport',data_blob,'sss.jpg');

    },
    dataURItoBlob(base64Data){
      var byteString;
      if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1]);
      else
        byteString = unescape(base64Data.split(',')[1]);
      var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {type:mimeString});
    },
    clear(){
      var _this = this;
      _this.$refs.signature1.clear();
    },
    undo(){
      var _this = this;
      _this.$refs.signature1.undo();
    },
  }
}
</script>

<style scoped>
  .bmdiv{z-index: 1000;left: 0;right: 0;top: 0;bottom: 0;background: rgba(0, 0, 0, .2);}
  .bmdiv::after{content: '';display: inline-block;height: 100%;vertical-align: middle;}
  .bmdiv .content-div{width:100vw;height: 83.67vw;position: absolute;background: #fff;bottom: 0;}
  .bmdiv .content-div .close{right: 0;top: 0;width: 8.28vw;height: 8.28vw;line-height: 8.28vw;background: #147ad8;position: absolute;}
  .bmdiv .content-div button{background: #147ad8;border: none;display: inline-block;width: 16.1vw;height: 6.9vw;margin-top: 2.3vw;color: #FFF;border-radius: 1.38vw}
</style>



// WEBPACK FOOTER //
// src/components/item/vueSignatureMobile.vue